import User from "./User";
import Expert from "./Expert";

function App() {
  const role = window.location.pathname.includes("expert") ? "expert" : "user";
  return role === "expert" ? <Expert /> : <User />;
}

export default App;
